import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {getCurrentTeams} from '../api/teamAPI';
import {Team} from '../interfaces';

export interface TeamState {
  teams: Team[];
  status: 'idle' | 'loading' | 'failed';
  error: unknown;
}

const initialState: TeamState = {
  teams: [],
  status: 'idle',
  error: null,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
const getCurrentTeamsAsync = createAsyncThunk(
  'profile/getCurrentTeams',
  async (teamsData, {rejectWithValue}) => {
    try {
      const response = await getCurrentTeams();
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    } catch (err: unknown) {
      const error = err as Error;
      return rejectWithValue({
        name: error.name,
        message: error.message,
      });
    }
  },
);

export const teamSlice = createSlice({
  name: 'team',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {
    builder
      .addCase(getCurrentTeamsAsync.pending, state => {
        state.status = 'loading';
      })
      .addCase(getCurrentTeamsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.teams = action.payload.teams;
        state.error = null;
      })
      .addCase(getCurrentTeamsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.teams = [];
        state.error = action.payload;
      });
  },
});

export default teamSlice.reducer;

export {getCurrentTeamsAsync};
